import { h, Component } from 'preact';
import { observer } from 'mobx-preact';

import PubSub, { topics } from '../../lib/pubsub';

import Input from '../form/input';
import TagTree from './tree';

import util from '../../lib/util';
import style from './style.css';

const initialState = {
    height: 100,
    windowHeight: 0,
    loading: false,
    view: {
        countries: false,
        languages: false,
        brands: false,
    },
};

@observer
class ArticleList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ...initialState,
        };
        this.updateTimer = {};

        const { articleStore } = this.props.stores;
        articleStore.toggleQueryfilter('status', 'all', { setValue: true });
        articleStore.list(false, { addData: ['tagList', 'tagIdRef'] });
        this.subscriptions();
    }

    subscriptions() {
        PubSub.subscribe(topics.LEFT_MENU_HEIGHT_UPDATED, (height) => {
            this.setState({ height });
        });
    }

    handleScroll = () => {
        const { loading } = this.state;
        const { articleStore } = this.props.stores;
        const { totalAppend, limit } = articleStore;
        if (window.innerHeight + document.documentElement.scrollTop + 500
            < document.documentElement.offsetHeight) return;
        if (loading) return;

        let offset = articleStore.offset;
        if (offset === 0 || totalAppend > 0) {
            offset += limit;
            clearTimeout(this.scrollLoader);
            this.scrollLoader = setTimeout(async () => {
                this.setState({ loading: true });
                articleStore.updateOffset(offset);
                await articleStore.list(true);
                this.setState({ loading: false });
            }, 500);
        }
    }

    componentDidMount() {
        window.addEventListener('scroll', this.handleScroll);
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
    }

    async updateField(id, field, value) {
        const { articleStore } = this.props.stores;
        articleStore.updateField(id, field, value);

        clearTimeout(this.updateTimer[field]);
        this.updateTimer[field] = setTimeout(async () => {
            this.doUpdateField(id, field, value);
        }, 500);
    }

    async doUpdateField(id, field, value) {
        const { articleStore } = this.props.stores;
        await articleStore.saveField(id, field, value);
    }

    createNewArticle = async () => {
        const { articleStore, dealerStore } = this.props.stores;
        const { realDealer } = dealerStore;
        await articleStore.create({
            ...articleStore.queryFilter,
            author: realDealer.email,
            status: 1,
            title: 'No title yet for this shiny new article...',
        });
        await articleStore.list(false, { addData: ['tagList', 'tagIdRef'] });
    }

    render() {
        const { loading, height } = this.state;
        const { articleStore } = this.props.stores;
        const { imageServer } = this.props;
        const { articles, queryFilter, tagIdRef, saved } = articleStore;

        return (
            <div class='container-fluid'>
                <div class='row'>
                    <div class='col-12'>
                        <small class='text-muted font-weight-lighter float-right ml-4'>
                            Total: {articleStore.total}<br />
                        </small>

                        <button class={`ml-2 float-right btn btn-sm btn-success`}
                            onClick={this.createNewArticle}
                        >
                            <i class='far fa-file mr-2' />
                            New article
                        </button>

                        <button class={`mr-2 btn btn-sm ${util.buttonClass(queryFilter.status, 'article')}`}
                            onClick={() => articleStore.toggleQueryfilter('status', util.cyclevalues(queryFilter.status, ['all', 2, 1, 3]), { setValue: 1 })}
                        >
                            <i class={`fas fa-toggle-${queryFilter.status ? 'on' : 'off'} mr-1`} />
                            Status
                        </button>

                        <button class={`mr-2 btn btn-sm ${util.buttonClass(queryFilter.showall)}`}
                            onClick={() => articleStore.toggleQueryfilter('showall', util.cyclevalues(queryFilter.showall, [null, 1]), { setValue: 1 })}
                        >
                            <i class={`fas fa-toggle-${queryFilter.showall ? 'on' : 'off'} mr-1`} />
                            Show all
                        </button>

                        <span class='float-left form-row align-items-center mr-5'>
                            <div class='col-auto'>
                                <input type='text' class='form-control form-control-sm' id='inlineFormInputName' placeholder='Search for articles...'
                                    onInput={e => articleStore.toggleQueryfilter('search', e.target.value, { setValue: true, skipUpdate: true, setTimer: true })}
                                    value={queryFilter.search}
                                />
                            </div>
                            <div class='col-auto'>
                                <button type='button' class='btn btn-sm btn-primary' onClick={() => articleStore.list()}>Search</button>
                            </div>
                        </span>
                    </div>
                </div>
                <div class='row'>
                    <div class='col-2 fixed-top overflow-auto'
                        style={`margin-top: ${height + 60}px; height: calc(100% - ${height + 60}px);`}
                    >
                        <small>
                            <TagTree {...this.props} />
                        </small>
                        <div class='text-center mt-4 mb-2'>
                            <small class='text-muted'>
                                <i class='fas fa-ellipsis-h' />
                            </small>
                        </div>
                    </div>
                    <div class='col-10 offset-2'>

                        {queryFilter.search && <div class='w-100 text-left mt-2 mb-5'>
                            <h1><i class='fas fa-search' /> Search results</h1>
                            Found {articleStore.total} results in your search for "{queryFilter.search}".<br />
                            <button class='btn btn-sm btn-warning mt-2'
                                onClick={() => articleStore.toggleQueryfilter('search', '', { setValue: true, skipUpdate: true, setTimer: true })}
                            >
                                <i class='fas fa-times' /> Reset search
                            </button>
                        </div>}

                        <div class='table-responsive'>
                            <table class={`${style.table} table table-striped table-sm table-borderless`}>
                                <thead>
                                    {articleStore.sort !== articleStore.defaultSort && <tr>
                                        <th colspan='8'>
                                            <span class={`${style.pointerCursor} mr-2 badge badge-pill badge-secondary`} onClick={() => articleStore.resetSort()}>
                                                <i class='fas fa-times-circle' /> Reset sort
                                            </span>
                                        </th>
                                    </tr>}
                                    <tr>
                                        <th style='width: 5%' class='text-right'>
                                            <span class={style.pointerCursor} onClick={() => articleStore.toggleSort('id', '-')}>
                                                Article# {util.getSortIcon('id', articleStore.sort)}
                                            </span>
                                        </th>
                                        <th style='width: 5%' class='text-center'>Image</th>
                                        
                                        <th style='width: 35%'>
                                            <span class={style.pointerCursor} onClick={() => articleStore.toggleSort('title', '')}>
                                                Title {util.getSortIcon('title', articleStore.sort)}
                                            </span>
                                        </th>
                                        <th style='width: 5%' class='text-right'>
                                            <span class={style.pointerCursor} onClick={() => articleStore.toggleSort('sort', '')}>
                                                Sort {util.getSortIcon('sort', articleStore.sort)}
                                            </span>
                                        </th>
                                        <th style='width: 5%' class='text-center'>
                                            <span class={style.pointerCursor} onClick={() => articleStore.toggleSort('status', '-')}>
                                                Status {util.getSortIcon('status', articleStore.sort)}
                                            </span>
                                        </th>
                                        <th style='width: 20%'>Tag</th>
                                        <th style='width: 10%'>
                                            <span class={style.pointerCursor} onClick={() => articleStore.toggleSort('author', '-')}>
                                                Author {util.getSortIcon('author', articleStore.sort)}
                                            </span>
                                        </th>
                                        <th style='width: 10%' class='text-right'>
                                            <span class={style.pointerCursor} onClick={() => articleStore.toggleSort('create_date', '-')}>
                                                Created {util.getSortIcon('create_date', articleStore.sort)}
                                            </span>
                                        </th>
                                        <th style='width: 5%' class='text-right'>Offline</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {!articles.length && <tr class={`${style.tableline}`}>
                                        <td class='text-center' colspan='9'>
                                            <h5>No articles found</h5>
                                            Try using the "Show all" button if you are missing some articles.
                                        </td>
                                    </tr>}
                                    {articles && articles.map(article => (
                                        <tr class={`${style.tableline}`}>
                                            <td class='text-right'>
                                                {article.id}
                                            </td>
                                            <td class='text-center'>
                                                {util.asString(article, 'images', 'tiny') &&
                                                    <a href={`/articles/${article.id}/Basics`}>
                                                        <img src={`${imageServer}/${util.asString(article, 'images', 'tiny')}`} class='rounded' />
                                                    </a>}
                                            </td>
                                            <td>
                                                <div>
                                                    <a href={`/articles/${article.id}/Basics`}>
                                                        {article.title || '(No title)'}
                                                    </a>
                                                </div>
                                                {article.url && <div><small><i class='fas fa-link mr-1' /> {article.url}</small></div>}
                                                {article.youtube && <div><small><i class='fab fa-youtube mr-1' /> {article.youtube}</small></div>}
                                                {article.productsearch && <div><small><i class='fas fa-search mr-1' /> {article.productsearch}</small></div>}
                                            </td>
                                            <td class='text-right'>
                                                <Input
                                                    id={article.id}
                                                    className='text-right form-control-sm'
                                                    isValid={saved[`sort.${article.id}`]}
                                                    name='sort'
                                                    value={article.sort}
                                                    onInput={e => this.updateField(article.id, 'sort', e.target.value)}
                                                    hideHelp={1}
                                                />
                                            </td>
                                            <td class='text-center'>
                                                <span
                                                    class={`mr-1 badge ${style.pointerCursor} badge-${util.colorClass(article.status, 'article')}`}
                                                    onClick={() => articleStore.saveField(article.id, 'status', util.cyclevalues(article.status, [1, 2, 3]), true)}
                                                >
                                                    {util.statusText(article.status, 'article')}
                                                </span>
                                            </td>
                                            <td>
                                                {util.asString(tagIdRef, article.tag, 'name') && <span class='mr-2 badge badge-primary'>{util.asString(tagIdRef, article.tag, 'name')}</span>}
                                                {article.tags}
                                            </td>
                                            <td>
                                                {article.author}
                                            </td>
                                            <td class='text-right'>
                                                <div>{util.ffeDateTime(article.create_date)}</div>
                                                {article.updated && <div><small class='text-muted'><i class='fas fa-edit' /> {util.ffeDateTime(article.updated)}</small></div>}

                                            </td>
                                            <td class='text-right'>
                                                <span
                                                    class={`mr-1 badge ${style.pointerCursor} badge-${article.offline === 1 ? 'success' : 'danger'}`}
                                                    onClick={() => articleStore.saveField(article.id, `offline`, article.offline === 1 ? 0 : 1, true)}
                                                >
                                                    &nbsp;<i class={`fas fa-trash${article.offline === 1 ? '-restore' : ''}`} /> {article.offline === 1 ? 'Restore' : 'Delete'}
                                                </span>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>

                    </div>
                </div>
                {loading && <div class='row'>
                    <div class='col-12 text-center'>
                        <div class='spinner-border text-success' role='status'>
                            <span class='sr-only'>Loading...</span>
                        </div>
                    </div>
                </div>}
                <div class='text-center mt-4 mb-2'>
                    <small class='text-muted'>
                        <i class='fas fa-ellipsis-h' />
                    </small>
                </div>
            </div>
        );
    }
}

export default ArticleList;




// WEBPACK FOOTER //
// ./components/articles/list.js